var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"px-3 py-1 rounded-full shadow",class:_vm.classes},[_vm._v(_vm._s(_vm.status))])}
var staticRenderFns = []

export { render, staticRenderFns }